import Axios from "axios";
import { baseApi, baseApiV1 } from "../../constants/Presets";
import { getCustomParam } from "./helper";

export function FetchCustomDataList(payload) {
  const url = `${baseApi}v1/customDatapoints?`;
  const params = [];
  // const filters = encodeURIComponent(JSON.stringify(getCustomParam(payload)));
  /* istanbul ignore if */
  if (payload.filters) {
    const filters = encodeURIComponent(JSON.stringify(payload.filters));
    params.push(`filters=${filters}`);
  }
  const size = 1000;
  params.push(`size=${size}`);
  if (payload.queryValue) {
    const query = payload.queryValue;
    params.push(`query=${query}`);
  }
  const paramStr = params.join("&");
  return Axios.get(url + paramStr);
}
export function FetchACustomData(payload) {
  const url = `${baseApi}v1/customDatapoints/unmappedKey?`;
  const params = [];
  const messageName = payload.messageName;
  params.push(`messageName=${messageName}`);
  const type = payload.type;
  params.push(`type=${type}`);
  const paramStr = params.join("&");
  return Axios.get(url + paramStr);
}
export function FetchACustomDataAlias(payload) {
  const url = `${baseApi}v1/customDatapoints/alias?`;
  const params = [];
  params.push(`masterKey=${payload}`);
  // const type = payload.type;
  // params.push(`type=${type}`);
  const paramStr = params.join("&");
  return Axios.get(url + paramStr);
}
export function DeleteACustomDataAlias(payload) {
  const url = `${baseApi}v1/customDatapoints/deleteAlias`;
  return Axios.delete(url, { data: payload });
}
export function RemoveMappedKey(payload) {
  const url = `${baseApi}v1/customDatapoints/unMapFromAlias`;
  return Axios.patch(url, payload);
}
export function MapToAlias(payload) {
  const url = `${baseApi}v1/customDatapoints/mapToAlias`;
  return Axios.patch(url, payload);
}
export function CreateAlias(payload) {
  const url = `${baseApi}v2/customDatapoints/alias`;
  return Axios.post(url, payload);
}
export function UpdateAlias(payload) {
  const url = `${baseApi}v1/customDatapoints/alias`;
  return Axios.patch(url, payload);
}
export function FetchAliasLogs(payload) {
  return Axios({
    method: "get",
    url: `${baseApiV1}customDatapoints/changeLog/${payload}`,
  });
}
